import { PerfumeTunnelPageStepId } from "./PerfumeTunnelPageStepId";

export enum PathFragment {
  Account = "account",
  PerfumeWorkshop = "perfume-workshop",
  PerfumeDetails = "perfume-details",
  Perfumes = "perfumes",
  Workshop = "workshop",
  Admin = "admin",
  IngredientInventory = "ingredient-inventory",
  IngredientLots = "ingredient-lots",
}

export const PageLink = {
  Home: "/",
  Account: `/${PathFragment.Account}`,
  PerfumeWorkshop: `/${PathFragment.PerfumeWorkshop}`,
  Perfumes: `/${PathFragment.Admin}/${PathFragment.Perfumes}`,
  loginWithRedirect: (redirect?: string) => {
    const queryParams = redirect ? `?${new URLSearchParams({ redirect })}` : "";
    return `${PageLink.Account}${queryParams}`;
  },
  perfumeDetails: (perfumeId: string) =>
    `/${PathFragment.Perfumes}/${encodeURIComponent(perfumeId)}`,
  perfumeWorkshop: ({
    perfumeId,
    step,
  }: {
    perfumeId: string | null;
    step?: PerfumeTunnelPageStepId;
  }) => {
    if (perfumeId === null) {
      throw Error("Can't navigate to perfume workshop without perfumeId");
    }
    const stepString = PerfumeTunnelPageStepId[step ?? PerfumeTunnelPageStepId.Parfum];
    return `/${PathFragment.PerfumeWorkshop}/${encodeURIComponent(perfumeId)}/${encodeURIComponent(
      stepString,
    )}`;
  },

  IngredientLots: `/${PathFragment.Admin}/${PathFragment.IngredientLots}`,

  workshopLocation: ({ workshopLocationId }: { workshopLocationId: string }) => {
    const workshopFragment = `${PathFragment.Workshop}/${encodeURIComponent(workshopLocationId)}`;
    return `/${workshopFragment}`;
  },
} as const;

export function isRouteRequireAuthenticatedUser(path: string) {
  return path.startsWith(PathFragment.Admin);
}
